import { DownloadService } from '@src/common/services/DownloadService';
import { getFileIcon } from '@src/common/utils/FileIcon';
import { DocumentsClient } from '@src/documents/services/DocumentsClient';

interface Props {
  document: { id?: string; key?: string };
  fontSize?: 'small' | 'medium' | 'large';
  download?: (documentId: string) => Promise<{ blob: Blob; filename: string }>;
}

export const ViewableDocumentShortcut = ({
  document,
  fontSize,
  download = DocumentsClient.downloadWithId,
}: Props) => {
  const CurrentFileIcon = getFileIcon(document.key);
  const openDocumentInNewTab = async () => {
    if (document.id) {
      await openInNewTab(document.id);
    }
  };
  const openInNewTab = async (documentId: string) => {
    const { blob } = await download(documentId);
    void DownloadService.openInNewTab(blob);
  };

  return (
    <CurrentFileIcon
      onClick={openDocumentInNewTab}
      fontSize={fontSize || 'medium'}
      style={{ cursor: 'pointer' }}
      aria-label={`${document.id}`}
    />
  );
};
